/**
 * Define grades
 */

const grades = {
  Null: -9999,
  Unassigned: -1,
  Kindergarten: 0,
  Other: 50,
  AllGrades: 100,
  Grades3To8: 108,
  Top10Teachers: 109,
  Top10FamilyLink: 110,
  Top100Students: 111,
  Top200Students: 112,
  Top500Students: 113,
  Top100StudentsUpTo200: 115
}

const DEFAULT_GRADE_INDEX = 1

/**
 * returns grade from id
 */
const getGradeFromId = (id: number | undefined) => {
  return Object.values(grades)[id || DEFAULT_GRADE_INDEX]
}

/**
 * returns formatted grade from id
 */
const MIN_STANDARD_GRADE = 1
const MAX_STANDARD_GRADE = 12

export function ToGradeTextString(grade: number | undefined = grades.Null) {
  if (grade >= MIN_STANDARD_GRADE && grade <= MAX_STANDARD_GRADE) {
    return grade.toString()
  }
  switch (grade) {
    case grades.Null:
      return 'Null'
    case grades.Unassigned:
      return 'Unassigned'
    case grades.Kindergarten:
      return 'PK / Kindergarten'
    case grades.AllGrades:
      return 'All Grades'
    case grades.Grades3To8:
      return 'Grades 3 to 8'
    case grades.Other:
      return 'Other'

    case grades.Top10Teachers:
      return 'Top 10 Teachers'
    case grades.Top10FamilyLink:
      return 'Top 10 Family Link'
    case grades.Top100Students:
      return 'Top 100 Students'
    case grades.Top200Students:
      return 'Top 200 Students'
    case grades.Top500Students:
      return 'Top 500 Students'
    case grades.Top100StudentsUpTo200:
      return 'Top 100 Students Up To 200'

    default:
      return grade.toString()
  }
}

export default getGradeFromId
